import { isPhraseFound } from 'helpers/filtering';
import { deepFind } from 'shared/utils/object';

function matchesSearchPhrase(item: object, searchPhrase: string, searchableFields: readonly string[]): boolean {
  return searchableFields.some((field) => isPhraseFound(deepFind(item, field), searchPhrase));
}

/**
 * The items whose searchable fields (dotted paths, e.g. `parties.companyShortLabel`)
 * contain the phrase; all of them without a phrase.
 */
export function filterBySearchPhrase<T extends object>(
  items: T[],
  searchPhrase: string,
  searchableFields: readonly string[]
): T[] {
  if (!searchPhrase) {
    return items;
  }
  return items.filter((item) => matchesSearchPhrase(item, searchPhrase, searchableFields));
}
